import { InteractionTypeEnum } from "@examspark/types";

export const questionTypeMeta: {
  [key in InteractionTypeEnum]: { label: string };
} = {
  [InteractionTypeEnum.Choice]: {
    label: "Multiple Choice",
  },
  [InteractionTypeEnum.ChoiceSingle]: {
    label: "Multiple Choice: Single",
  },
  [InteractionTypeEnum.ChoiceMulti]: {
    label: "Multiple Choice: Multi",
  },
  [InteractionTypeEnum.TextExtended]: {
    label: "Extended Text",
  },
  [InteractionTypeEnum.TextExtendedShortReading]: {
    label: "Short Const ... (Reading)",
  },
  [InteractionTypeEnum.TextExtendedShortWriting]: {
    label: "Short Const ... (Writing)",
  },
  [InteractionTypeEnum.TextExtendedEssay]: {
    label: "Essay/Composition",
  },
  [InteractionTypeEnum.TextInline]: {
    label: "Inline Text",
  },
  [InteractionTypeEnum.TextInlineEntry]: {
    label: "Inline Text Entry",
  },
  [InteractionTypeEnum.TextInlineNumericEntry]: {
    label: "Inline Numeric Entry",
  },
  [InteractionTypeEnum.TextInlineMathEntry]: {
    label: "Inline Math Entry",
  },
  [InteractionTypeEnum.TextInlineChoice]: {
    label: "Inline Text Choice",
  },
  [InteractionTypeEnum.TextSelectable]: {
    label: "Selectable Text",
  },
  [InteractionTypeEnum.TextGapMatch]: {
    label: "Gap Match",
  },
  [InteractionTypeEnum.Order]: {
    label: "Sequence",
  },
  [InteractionTypeEnum.MatchTable]: {
    label: "Match Table",
  },
  [InteractionTypeEnum.Match]: {
    label: "Match",
  },
  [InteractionTypeEnum.Associate]: {
    label: "Associate",
  },
  [InteractionTypeEnum.GraphicHotspot]: {
    label: "Hotspot",
  },
  [InteractionTypeEnum.Drawing]: {
    label: "Drawing",
  },
  [InteractionTypeEnum.GraphicGapMatch]: {
    label: "Graphic Gap Match",
  },
  [InteractionTypeEnum.GraphicAssociate]: {
    label: "Graphic Associate",
  },
  [InteractionTypeEnum.GraphicOrder]: {
    label: "Graphic Order",
  },
  [InteractionTypeEnum.GraphicSelectPoint]: {
    label: "Select Point",
  },
  [InteractionTypeEnum.GraphicPositionObject]: {
    label: "Position Object",
  },
  [InteractionTypeEnum.Audio]: {
    label: "Audio",
  },
  [InteractionTypeEnum.Gridded]: {
    label: "Bubble Grid",
  },
  [InteractionTypeEnum.FractionModel]: {
    label: "Fraction Model (Shade)",
  },
  [InteractionTypeEnum.FractionModelConstruct]: {
    label: "Fraction Model (Construct)",
  },
  [InteractionTypeEnum.CartesianInequality]: {
    label: "Inequality",
  },
  [InteractionTypeEnum.Slider]: {
    label: "Slider",
  },
  [InteractionTypeEnum.CartesianGraph]: {
    label: "Cartesian Graph",
  },
  [InteractionTypeEnum.NumberLinePlot]: {
    label: "Number Line",
  },
  [InteractionTypeEnum.BarChart]: {
    label: "Bar Chart",
  },
  [InteractionTypeEnum.LineChart]: {
    label: "Line Chart",
  },
};

export const questionTypesList = [
  InteractionTypeEnum.Choice,
  InteractionTypeEnum.TextExtended,
  InteractionTypeEnum.TextInlineChoice,
  InteractionTypeEnum.TextInlineEntry,
  InteractionTypeEnum.TextInlineMathEntry,
  InteractionTypeEnum.TextSelectable,
  InteractionTypeEnum.TextGapMatch,
  InteractionTypeEnum.Order,
  InteractionTypeEnum.Match,
  InteractionTypeEnum.MatchTable,
  InteractionTypeEnum.Associate,
  InteractionTypeEnum.GraphicHotspot,
  InteractionTypeEnum.Drawing,
  InteractionTypeEnum.GraphicGapMatch,
  InteractionTypeEnum.GraphicAssociate,
  InteractionTypeEnum.GraphicOrder,
  InteractionTypeEnum.GraphicSelectPoint,
  InteractionTypeEnum.GraphicPositionObject,
  InteractionTypeEnum.CartesianInequality,
  InteractionTypeEnum.Audio,
  InteractionTypeEnum.Gridded,
  InteractionTypeEnum.FractionModel,
  InteractionTypeEnum.Slider,
  InteractionTypeEnum.CartesianGraph,
  InteractionTypeEnum.NumberLinePlot,
  InteractionTypeEnum.BarChart,
  InteractionTypeEnum.LineChart,
];

export const INTERACTION_MAP: Record<
  InteractionTypeEnum,
  {
    label: string;
    className?: string;
    longLabel?: string;
    synthetic?: boolean;
    derivedFrom?: InteractionTypeEnum;
  }
> = {
  [InteractionTypeEnum.Choice]: {
    className: "MultipleChoice",
    label: "Choice",
    longLabel: "Multiple Choice",
  },
  [InteractionTypeEnum.ChoiceSingle]: {
    label: "Choice: Single",
    longLabel: "Multiple Choice: Single",
    derivedFrom: InteractionTypeEnum.Choice,
  },
  [InteractionTypeEnum.ChoiceMulti]: {
    label: "Choice: Multiple",
    longLabel: "Multiple Choice: Multi",
    derivedFrom: InteractionTypeEnum.Choice,
  },
  [InteractionTypeEnum.TextExtended]: {
    className: "ExtendedText",
    label: "Extended Text",
  },
  [InteractionTypeEnum.TextExtendedShortReading]: {
    className: "ExtendedText",
    label: "Short Constructed Response: Reading",
  },
  [InteractionTypeEnum.TextExtendedShortWriting]: {
    className: "ExtendedText",
    label: "Short Constructed Response: Writing",
  },
  [InteractionTypeEnum.TextExtendedEssay]: {
    className: "ExtendedText",
    label: "Essay/Composition",
  },
  [InteractionTypeEnum.TextGapMatch]: {
    className: "TextGapMatch",
    label: "Gap Match",
  },
  [InteractionTypeEnum.TextInline]: {
    className: "InlineText",
    label: "Inline Text",
  },
  [InteractionTypeEnum.TextInlineChoice]: {
    className: "InlineText",
    label: "Inline Text: Choice",
    derivedFrom: InteractionTypeEnum.TextInline,
  },
  [InteractionTypeEnum.TextInlineMathEntry]: {
    className: "InlineText",
    label: "Inline Text: Math Entry",
    derivedFrom: InteractionTypeEnum.TextInline,
  },
  [InteractionTypeEnum.TextInlineNumericEntry]: {
    className: "InlineText",
    label: "Inline Text: Numeric Entry",
    derivedFrom: InteractionTypeEnum.TextInline,
  },
  [InteractionTypeEnum.TextInlineEntry]: {
    className: "InlineText",
    label: "Inline Text: Entry",
    derivedFrom: InteractionTypeEnum.TextInline,
  },
  [InteractionTypeEnum.TextSelectable]: {
    className: "SelectableText",
    label: "Selectable Text",
  },
  [InteractionTypeEnum.Order]: {
    className: "Sequence",
    label: "Sequence",
  },
  [InteractionTypeEnum.Match]: {
    className: "Match",
    label: "Match",
  },
  [InteractionTypeEnum.MatchTable]: {
    className: "MatchTable",
    label: "Match Table",
  },
  [InteractionTypeEnum.Associate]: {
    className: "Associate",
    label: "Associate",
  },
  [InteractionTypeEnum.GraphicGapMatch]: {
    className: "GraphicGapMatch",
    label: "Graphic Gap Match",
  },
  [InteractionTypeEnum.Drawing]: {
    className: "Drawing",
    label: "Drawing",
  },
  [InteractionTypeEnum.GraphicHotspot]: {
    className: "GraphicHotspot",
    label: "Graphic Hotspot",
  },
  [InteractionTypeEnum.GraphicAssociate]: {
    className: "GraphicAssociate",
    label: "Graphic Associate",
  },
  [InteractionTypeEnum.CartesianInequality]: {
    className: "CartesianInequality",
    label: "Inequality",
  },
  [InteractionTypeEnum.GraphicOrder]: {
    className: "GraphicOrder",
    label: "Graphic Order",
  },
  [InteractionTypeEnum.GraphicSelectPoint]: {
    className: "GraphicSelectPoint",
    label: "Graphic Select Point",
  },
  [InteractionTypeEnum.GraphicPositionObject]: {
    className: "GraphicPositionObject",
    label: "Graphic Position",
  },
  [InteractionTypeEnum.Audio]: {
    className: "Audio",
    label: "Audio",
  },
  [InteractionTypeEnum.Gridded]: {
    className: "Gridded",
    label: "Gridded",
  },
  [InteractionTypeEnum.FractionModel]: {
    className: "FractionModel",
    label: "Fraction Model (Shade)",
  },
  [InteractionTypeEnum.FractionModelConstruct]: {
    className: "FractionModelConstruct",
    label: "Fraction Model (Construct)",
  },
  [InteractionTypeEnum.Slider]: {
    className: "Slider",
    label: "Slider",
  },
  [InteractionTypeEnum.CartesianGraph]: {
    className: "CartesianGraph",
    label: "Cartesian Graph",
  },
  [InteractionTypeEnum.NumberLinePlot]: {
    className: "NumberLine",
    label: "Number Line",
  },
  [InteractionTypeEnum.BarChart]: {
    className: "BarChart",
    label: "Bar Chart",
  },
  [InteractionTypeEnum.LineChart]: {
    className: "LineChart",
    label: "Line Chart",
  },
};

export const hasDerivedInteractionTypes = (
  interactionType: string,
  map?: typeof INTERACTION_MAP,
) => {
  return Object.values(map ?? INTERACTION_MAP).some(
    (int) => int.derivedFrom === interactionType,
  );
};
